import React, { Children } from 'react';

function CardContentImage({ background, source, alt, role, ariaHidden, children }) {
  const style = background ? { backgroundImage: 'url(' + background + ')' } : undefined;
  const hasChildren = Children.toArray(children).filter((child) => child !== undefined).length > 0;

  return (
    <div className="content__image" style={style} aria-hidden={!hasChildren ? ariaHidden : undefined}>
      {!background ? (
        <div>
          {source && (
            <img
              src={source}
              alt={role === 'presentation' ? '' : alt}
              role={role}
              aria-hidden={hasChildren ? ariaHidden : undefined}
            />
          )}
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}

export default CardContentImage;
